import { render, staticRenderFns } from "./Outros.vue?vue&type=template&id=38b8ce8a&"
import script from "./Outros.vue?vue&type=script&lang=js&"
export * from "./Outros.vue?vue&type=script&lang=js&"
import style0 from "./Outros.vue?vue&type=style&index=0&id=38b8ce8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports